<template>
  <div>
    <Header />
    <div class="dashboard">
      <nav class="side-nav">
        <Sidebar :item="item" />
      </nav>

      <div class="main-content">
        <div class="welcome">
          <div class="dashboard__header">
            <span>Hi {{ companyName }},</span>
            <p>Everything your business needs to be much more is here</p>
          </div>
        </div>

        <div class="cards">
          <div class="horizontal-cards">
            <div class="f_card">
              <div class="container">
                <div class="dashboard__links--content-icon">
                  <img src="./../../assets/images/group.svg" alt />
                </div>
                <div class="dashboard__links--content-text-container">
                  <h4 class="dashboard__links--content-text-heading">
                    Staff strength
                  </h4>
                  <p class="dashboard__links--content-text-info">
                    Number of staff: {{ employeesCount }} {{ employeeLabel }}
                  </p>
                  <div
                    class="dashboard__links--content-text-button"
                    role="button"
                  >
                    <routerLink to="/employee">View Employees</routerLink>
                  </div>
                </div>
              </div>
            </div>
            <div class="f_card">
              <div class="container">
                <div class="dashboard__links--content-icon">
                  <img src="./../../assets/images/notepad.svg" alt />
                </div>
                <div class="dashboard__links--content-text-container">
                  <h4 class="dashboard__links--content-text-heading">
                    Payroll
                  </h4>
                  <p class="dashboard__links--content-text-info">
                    Pending Payrolls: {{ pendingQueriesCount }} pending
                  </p>
                  <div
                    class="dashboard__links--content-text-button"
                    role="button"
                  >
                    <routerLink to="/payroll/regular/initiate"
                      >Run Payroll</routerLink
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="f_card">
              <div class="container">
                <div class="dashboard__links--content-icon">
                  <img src="./../../assets/images/cash.svg" alt />
                </div>
                <div class="dashboard__links--content-text-container">
                  <h4 class="dashboard__links--content-text-heading">
                    Payroll
                  </h4>
                  <p class="dashboard__links--content-text-info">
                    Next Payroll Date: {{ nextPayrollDate }}
                  </p>
                  <!-- <p class="dashboard__links--content-text-info">
                    Next Payroll Date: {{ nextPayrollDate }}
                  </p> -->
                  <div
                    class="dashboard__links--content-text-button"
                    role="button"
                  >
                    <routerLink to="/payroll">View Payroll</routerLink>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="larger-cards">
            <div class="larger-card chart">
              <div class="barchart-container">
                <h4>Payroll Stats</h4>
                <div class="custom-select__input">
                  <select v-model="yearInView">
                    <option
                      v-for="val in years"
                      v-bind:key="val.index"
                      :value="val"
                    >
                      {{ val }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>

                <div class="barchart-key">
                  <div>
                    <div class="barchart-key-left-dark"></div>
                    <div class="barchart-key-right">Expected&nbsp;Payouts</div>
                  </div>
                  <div>
                    <div class="barchart-key-left-light"></div>
                    <div class="barchart-key-right">
                      Unsuccessful&nbsp;Payouts
                    </div>
                  </div>
                </div>

                <div v-show="loader">
                  <div style="width: 55px; margin: 50px auto">
                    <PageLoader />
                  </div>
                </div>
                <div class="chart">
                  <canvas id="payroll-updates" height="400"></canvas>
                </div>
              </div>
            </div>
            <div class="f_card">
              <div class="dashboard__thinks--tasks">
                <!-- <p>Celebrations:</p> -->
                <div>
                  <h3>Things to do:</h3>
                  <p>You have {{ pendingTasksCount }} pending tasks today.</p>
                  <div class="dashboard__thinks--tasks-card">
                    <div class="dashboard__thinks--tasks-icon">
                      <img src="./../../assets/images/confetti.svg" alt />
                    </div>
                    <div class="dashboard__thinks--tasks-text">
                      <p>{{ tasksData.birthdays.date }}</p>
                      <p>{{ tasksData.birthdays.task }}</p>
                      <div v-show="tasksData.payroll.action">
                        <routerLink to="birthdays">
                          Go to birthdays
                        </routerLink>
                      </div>
                      <div v-show="tasksData.birthdays.action">
                        <routerLink to="birthdays"> Send a card </routerLink>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="dashboard__thinks--tasks-card">
                    <div class="dashboard__thinks--tasks-icon">
                      <img src="./../../assets/images/notepad.svg" alt />
                    </div>
                    <div class="dashboard__thinks--tasks-text">
                      <p>{{ tasksData.queries.date }}</p>
                      <p>{{ tasksData.queries.task }}</p>
                      <div v-show="tasksData.queries.action">
                        <routerLink to="birthdays"> Resolve </routerLink>
                      </div>
                    </div>
                  </div> -->
                  <div class="dashboard__thinks--tasks-card">
                    <div class="dashboard__thinks--tasks-icon">
                      <img src="./../../assets/images/cash.svg" alt />
                    </div>
                    <div class="dashboard__thinks--tasks-text">
                      <!-- <p>{{ tasksData.payroll.date }}</p> -->
                      <p>{{ nextPayrollDate }}</p>
                      <p>{{ tasksData.payroll.task }}</p>
                      <div v-show="tasksData.payroll.action">
                        <routerLink to="payroll">
                          Check payroll information
                        </routerLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="youtube__video--play" v-if="modal">
              <div>
                <p>
                  <span @click="closeModal">
                    <font-awesome-icon icon="times" />
                  </span>
                </p>
                <div>
                  <iframe
                    width="100%"
                    height="480"
                    src="https://www.youtube.com/embed/jHV7N__2nWY"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "../partials/header";
import Sidebar from "../partials/sidebar";
import * as types from "../../store/constant";
import PageLoader from "../partials/page-loader";
import Chart from "chart.js";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {
    Header,
    Sidebar,
    PageLoader,
  },
  data() {
    return {
      formattedDate: "",
      companyName: "Loading...",
      item: "dashboard",
      lastLogin: "",
      tasksData: {},
      dashboardData: {},
      birthdayCelebrant: [],
      birthdayLoader: true,
      modal: false,
      loader: true,
      employeesCount: 0,
      nextPayrollDate: null,
      pendingQueriesCount: 0,
      pendingTasksCount: 0,
      nextPayrollMonth: "",
      nextPayrollYear: "",
      yearInView: 2024,
      payrollMonth: "",
      payrollDay: "",
      countryId: "",
      years: [2024],
      barChartData: {
        type: "bar",
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sept",
            "Oct",
            "Nov",
            "Dec",
          ],
          datasets: [
            {
              label: "Expected Total",
              backgroundColor: [
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
                "#28A747",
              ],
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              backgroundColor: [
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
                "rgb(220 53 69 / 56%)",
              ],
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        options: {
          responsive: true,
          tooltips: {
            enabled: true,
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                display: true,
                stacked: false,
                ticks: {
                  // max: 1000000,
                  beginAtZero: true,
                  callback: function (value) {
                    if (parseInt(value, 10) >= 1000) {
                      return (
                        "₦" +
                        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      );
                    } else {
                      if (value === 0) {
                        return value;
                      }
                      return "₦" + value;
                    }
                  },
                },
                gridLines: {
                  display: true, // Display or hide horizontal grid lines
                },
              },
            ],
          },
        },
      },
    };
  },
  metaInfo: {
    title: 'HR Desk Dashboard - Manage Your HR Operations Efficiently',
    meta: [
      { name: 'description', content: ' Access the HR Desk Dashboard to manage all your HR operations in one place. Monitor performance, track key metrics, and streamline your HR processes with ease.' },
      { property: 'og:title', content: 'HR Desk Dashboard - Manage Your HR Operations Efficiently' },
      { property: 'og:description', content: ' Access the HR Desk Dashboard to manage all your HR operations in one place. Monitor performance, track key metrics, and streamline your HR processes with ease.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/dashboard' },
      { property: 'og:image', content: 'https://uniswitch-public-assets.s3.amazonaws.com/hrdesk-logo-white.png' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Dashboard - hrdeskHR Desk Dashboard - Manage Your HR Operations Efficiently' },
      { name: 'twitter:description', content: ' Access the HR Desk Dashboard to manage all your HR operations in one place. Monitor performance, track key metrics, and streamline your HR processes with ease.' },
      { name: 'twitter:image', content: 'https://uniswitch-public-assets.s3.amazonaws.com/hrdesk-logo-white.png' },
      { name: 'keywords', content: ' HR dashboard, HR operations, HR metrics, HR management, HR performance' },
    ]
  },
   computed: {
    employeeLabel() {
      return this.employeesCount === 1 ? 'employee' : 'employees';
    },
  },
  created() {
    this.loader = true;
    let user = this.$store.getters.currentAuthUser;

    this.companyName =
      user.company.trading_name.charAt(0).toUpperCase() +
      user.company.trading_name.slice(1);
    if (!user.last_login) {
      this.lastLogin = "checking last login...";
      return;
    }

    const companyId = this.$store.getters.currentAuthUser.employees.company_id;

    this.$http
      .get(`${types.COMPANY_GET_API}/${companyId}`)
      .then((resp) => {
        this.payrollMonth = +resp.data.data.payroll_month;
        this.payrollDay = +resp.data.data.payroll_month;
        this.formatDate();
      })
      .catch((err) => {
        this.payrollMonth = this.$store.state.payrollMonth;
      });

    const newDate = new Date(user.last_login + " UTC").toString();
    const getLoginTime = new Date(newDate)
      .toUTCString()
      .split(" ")
      .slice(0, 5)
      .join(" ");

    this.lastLogin = "Last login at " + getLoginTime;

    this.getCelebrants();
    this.getDashboardData();
    this.getPayrollDate();
    this.getTasksData();
  },
  methods: {
    formatDate() {
      const currentDate = new Date();
      const currentDay = currentDate.getDate();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      let targetMonth = currentMonth;
      let targetYear = currentYear;

      if (currentDay > this.payrollDay) {
        targetMonth += 1;
        if (targetMonth === 12) {
          targetMonth = 0;
          targetYear += 1;
        }
      }

      const targetDate = new Date(targetYear, targetMonth, this.payrollDay);

      const formattedDay = String(targetDate.getDate()).padStart(2, "0");
      const formattedMonth = String(targetDate.getMonth() + 1).padStart(2, "0");
      const formattedYear = targetDate.getFullYear();

      this.nextPayrollDate = `${formattedDay}-${formattedMonth}-${formattedYear}`;
    },
    placeholderData() {
      this.createChart("payroll-updates", this.barChartData);
    },
    getDashboardData() {
      this.$http
        .get(types.OVERVIEW_API)
        .then((resp) => {
          this.pendingQueriesCount = resp.data.data.pending_queries
            ? resp.data.data.pending_queries
            : 0;
          this.employeesCount = resp.data.data.total_employees
            ? resp.data.data.total_employees
            : 0;

          this.dashboard = resp.data.data;
          this.yearInView = resp.data.data.bar_chart.active_year;
          this.years = resp.data.data.bar_chart.years;

          this.barChartData.options.scales.yAxes[0].ticks.max =
            resp.data.data.bar_chart.maximum_y_limit;

          this.barChartData.data.datasets[0].data =
            resp.data.data.bar_chart.dataset1;
          this.barChartData.data.datasets[1].data =
            resp.data.data.bar_chart.dataset2;

          this.createChart("payroll-updates", this.barChartData);
          this.loader = false;
        })
        .catch(() => {
          this.placeholderData();
          this.loader = false;
        });
    },
    getTasksData() {
      const today = moment().format("dddd, MMMM Do");
      const nextPayrollDate = moment(this.nextPayrollDate, "DD-MM-YYYY").format(
        "dddd, MMMM Do"
      );

      this.tasksData = {
        birthdays: {
          date: today,
          task:
            this.birthdayCelebrant.length > 0
              ? `You have ${this.birthdayCelebrant.length} birthdays`
              : "No birthdays to celebrate",
          action: this.birthdayCelebrant.length > 0,
        },
        queries: {
          date: today,
          task: `You have ${this.pendingQueriesCount} pending queries`,
          action: this.pendingQueriesCount > 0,
        },
        payroll: {
          date: nextPayrollDate,
          task: `Next Payroll Date`,
          action: true,
        },
      };
    },
    getPayrollDate() {
      const payrollMonth = this.$store.state.payrollMonth;
      const now = new Date();
      this.payrollDay = Number(payrollMonth);
      const currentDay = now.getDate();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;
      let nextPayrollMonth;
      let nextPayrollYear;

      if (currentDay > this.payrollDay && currentMonth + 1 > 12) {
        nextPayrollMonth = 1;
        nextPayrollYear = currentYear + 1;
      } else if (currentDay > this.payrollDay && currentMonth + 1 < 12) {
        nextPayrollMonth = currentMonth + 1;
        nextPayrollYear = currentYear;
      } else {
        nextPayrollMonth = currentMonth;
        nextPayrollYear = currentYear;
      }

      nextPayrollMonth =
        nextPayrollMonth <= 9 ? "0" + nextPayrollMonth : nextPayrollMonth;

      this.nextPayrollMonth = nextPayrollMonth;
      this.nextPayrollYear = nextPayrollYear;

      this.nextPayrollDate = `${this.payrollDay}-${nextPayrollMonth}-${nextPayrollYear}`;
    },
    getCelebrants() {
      this.$http
        .get(types.GET_BIRTHDAYS)
        .then((resp) => {
          const celebrants = resp.data.data.data;
          this.pageLoading = false;
          if (celebrants.length) {
            for (let index of celebrants) {
              let date = index.user.date_of_birth.split("-")[2];

              if (parseInt(date, 10) >= new Date().getDate()) {
                if (index.user.date_of_birth) {
                  var newDate = new Date(index.user.date_of_birth);
                  var months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];
                  var days = [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ];

                  var monthName = months[newDate.getMonth()];
                  var dayNumber = newDate.getDate();
                  var dayName = days[newDate.getDay()];
                }
                this.birthdayCelebrants.push({
                  name: index.user.firstname,
                  day: `${dayName}, ${monthName} ${this.ordinalSuffix(
                    dayNumber
                  )}`,
                });
              }
            }
          }
          this.birthdayLoader = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    createChart(chartId, chartData) {
      if (document.getElementById(chartId)) {
        const ctx = document.getElementById(chartId).getContext("2d");
        new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      }
    },
    ordinalSuffix(dayNumber) {
      let percent = dayNumber % 10,
        k = dayNumber % 100;
      if (percent == 1 && k != 11) {
        return dayNumber + "st";
      }
      if (percent == 2 && k != 12) {
        return dayNumber + "nd";
      }
      if (percent == 3 && k != 13) {
        return dayNumber + "rd";
      }
      return dayNumber + "th";
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard {
  display: flex;
  margin-top: 3rem;

  .dashboard__header {
    text-align: center;

    > span {
      font-size: 2rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    p {
      font-size: 1rem;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      margin-top: 10px;
      color: #000000;
    }
  }

  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    overflow: auto;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .main-content {
    margin-left: 200px;
    flex: 1;
    padding: 20px;
    background: #fbfafa;
    overflow-y: auto;
    height: calc(100vh - 4rem);

    @media (max-width: 768px) {
      margin-left: 0;
    }
    .welcome {
      margin-bottom: 20px;
      margin-top: 3rem;
      text-align: center;

      h1 {
        font-size: 24px;
        color: #333;
      }
    }

    .cards {
      display: flex;
      flex-direction: column;

      .horizontal-cards {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;

        .f_card {
          flex: 1;
          margin: 0.2rem;

          > .container {
            max-width: 28rem;
            border-radius: 5px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
            padding: 30px 20px;
            display: flex;
            flex-direction: row;

            > .dashboard__links--content-icon {
              margin-top: 10px;
              border-radius: 50%;
              background-color: rgba(206, 206, 206, 0.398);
              padding: 11px;
              flex: 1 0 55px;
              height: 55px;

              > img {
                width: 100%;
                vertical-align: middle;
                text-align: center;
                line-height: 24px;
              }
            }

            > .dashboard__links--content-text-container {
              float: left;
              width: calc(100% - 4.2rem);
              padding-left: 10px;
              flex: 0 1 calc(100% - 4.025vw);

              > p,
              h4 {
                font-size: 1rem;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                margin-bottom: 12px;
                color: #000000;
              }

              > .dashboard__links--content-text-heading {
                font-weight: bolder;
                font-size: 1rem;
              }

              > .dashboard__links--content-text-info {
                font-size: 0.87rem;
                font-weight: 400;
              }

              > .dashboard__links--content-text-button {
                margin-top: 11px;
                line-height: 25px;

                > a {
                  display: inline-block;
                  width: 100px;
                  height: 27px;
                  border-radius: 3px;
                  background-color: #5099de;
                  color: #ffffff;
                  font-family: Nunito;
                  font-size: 12px;
                  font-stretch: normal;
                  font-style: normal;
                  letter-spacing: normal;
                  text-align: center;
                  vertical-align: middle;
                  text-decoration: none;
                }
              }
            }
          }
        }
      }

      .larger-cards {
        display: flex;
        justify-content: space-between;

        .larger-card {
          // width: 50%;
          margin-right: 0.4rem;
          .barchart-container {
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            background-color: #ffffff;
            overflow: hidden;
            height: 100%;
            padding-bottom: 100px;
            padding-top: 10px;
            padding-left: 40px;
            padding-right: 40px;

            > h4 {
              color: #000000;
              font-size: 1rem;
              display: inline-block;
              width: fit-content;
            }

            > .custom-select__input {
              width: 5rem;
              height: 2rem;
              background-color: #ffffff;
              overflow: hidden;
              position: relative;
              float: right;
              border-radius: 5px;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

              > select {
                // width: 188px;
                height: 35px;
                border: solid 1px #777777;
                background-color: transparent;
                border: 0;
                outline: 0;
                padding: 0 10px;
                text-align: left;
                -moz-appearance: none;
                -webkit-appearance: none;
                position: relative;
                z-index: 2;
                font-size: 14px;
                line-height: 1.67;
                color: #777777;
                display: inline-block;

                ::-ms-expand {
                  display: none;
                }
              }

              > div {
                position: absolute;
                color: #777777;
                top: 0;
                right: 0;
                width: 3rem;
                height: 100%;
                text-align: center;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
              }
            }

            .chart-row {
              .left-column {
                padding: 20px;
                height: 65vh;
                background-color: #fff;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
              }
              .left-column {
                .chart {
                  padding: 30px;
                  padding-top: 10px;
                }

                h4 {
                  font-family: Nunito;
                  font-size: 14px;
                  line-height: 1.79;
                  text-align: left;
                  color: #777777;
                }
              }
            }

            .barchart-key {
              width: 50%;
              padding-top: 30px;
              margin: auto;
              margin-top: 10px;
              margin-bottom: 20px;
              display: flex;
              flex-direction: row;
              justify-content: space-around;

              @media (max-width: 768px) {
                flex-direction: column;
              }

              > div {
                width: 30%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;

                > .barchart-key-left-light {
                  width: 10px;
                  height: 10px;
                  border-radius: 60px;
                  background-color: rgb(220 53 69 / 56%);
                }

                > .barchart-key-left-dark {
                  width: 10px;
                  height: 10px;
                  border-radius: 60px;
                  background-color: #28a745;
                }

                > .barchart-key-right {
                  width: calc(100% - 10px);
                  border-radius: 5px;
                  font-size: 0.879vw;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 2.17;
                  letter-spacing: normal;
                  text-align: center;
                  text-align: left;
                  padding-left: 10px;
                  color: #4d4f5c;

                  @media (max-width: 768px) {
                    font-size: 1rem;
                  }
                }
              }
            }
          }

          &.chart {
            width: 66.66%;
          }
        }

        .dashboard__thinks--tasks {
          // max-width: 32.5%;
          height: 100%;
          color: #000000;

          > div {
            padding: 20px;
            padding-top: 35px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            background-color: #ffffff;
            overflow: hidden;
            height: 100%;

            > h3 {
              font-size: 1rem;
              font-weight: bolder;
              color: #000000;
              margin-bottom: 10px;
            }

            > p {
              font-size: 0.948rem;
              color: #000000;
            }

            > .dashboard__thinks--tasks-card {
              color: #000000;
              background-color: #ffe7bd70;
              border: solid 2px #ffe7bd;
              min-height: 76px;
              margin-bottom: 20px;
              padding: 15px;
              font-size: 0.876rem;
              display: flex;
              flex-direction: row;
              width: 20rem;

              > .dashboard__thinks--tasks-icon {
                flex: 1 0 4rem;
                align-self: center;

                > img {
                  width: 70%;
                }
              }

              > .dashboard__thinks--tasks-text {
                flex: 0 0 calc(100% - 3.5rem);

                > p {
                  font-size: 0.952rem;
                  font-weight: bold;
                  color: #000000;
                  margin-bottom: 5px;
                }

                > div {
                  margin-top: 5px;

                  > a {
                    text-decoration: underline;
                  }
                }
              }
            }
          }
        }

        .f_card {
          width: 33.33%;
        }
      }

      @media (max-width: 768px) {
        .horizontal-cards,
        .larger-cards {
          flex-direction: column;

          .f_card {
            width: 100%;
            margin-bottom: 2rem;
            margin-right: 0;
            margin-left: 0;
          }

          .larger-card {
            margin-bottom: 2rem;
            &.chart {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
